module.exports = __webpack_public_path__ + "static/media/bell.d9229aa2.svg";